import React, { useState } from 'react';
import axios from 'axios';

const GeoCoder = () => {
  const [address, setAddress] = useState('');
  const [location, setLocation] = useState(null);

  // Replace with your actual Google Maps API Key
  const GOOGLE_API_KEY = 'AIzaSyBhWfHpzECIbbpbf44m9OyG66naQT7QqOo';

  const handleGeocode = async () => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`, {
          params: {
            address: address,
            key: GOOGLE_API_KEY,
          }
        });

      if (response.data.status === 'OK') {
        const { lat, lng } = response.data.results[0].geometry.location;
        setLocation({ lat, lng });
        console.log('Latitude: ', location.lat);
        console.log('Longitude: ', location.lng);
      } else {
        alert('Geocoding failed');
      }
    } catch (error) {
      console.error('Error during geocoding:', error);
    }
  };

  return (
    <div>
     {/*  <h2>Geocoding Example</h2> */}
      <input
        type="text"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        placeholder="Enter delivery address"
      />
      <button onClick={handleGeocode}>Accept delivery</button>{/*  Activate handler funtion for GeoCoder */}

      {location && (
        <div>
          {/* <p>Latitude: {location.lat}</p>
          <p>Longitude: {location.lng}</p> */}
          <p><a href={`https://waze.com/ul?ll=${location.lat},${location.lng}&navigate=yes`} target="_blank" rel="noopener noreferrer">Start Trip</a></p>
        </div>
        
      )}
    </div>
  );
};

export default GeoCoder;
